import './MicroserviceGitModal.css';

import B2BPopUpForm from '../../b2b-common/B2BPopUpForm';
import ReusableGitInfoPage from '../../b2b-common/pages/ReusableGitInfoPage';

const MicroserviceGitModal = ({ microservice = null, open, onCancel }) => {
    if (!microservice) return null;
    return (
        <B2BPopUpForm
            open={open}
            title={'Git Microservice: ' + microservice.microservice}
            onClose={() => {
                onCancel && onCancel();
            }}
            className={'microservice-git-modal'}
        >
            <ReusableGitInfoPage
                fetchMethod={microservice.gitAPI}
                showBanner={false}
                fetchMethodParams={microservice.fetchMethodParams}
            />
        </B2BPopUpForm>
    );
}

export default MicroserviceGitModal;